import React, { createContext, useCallback, useState } from 'react';
import { observer } from 'mobx-react';
import '../../../../../scss/neurosales/common/cmsTopBar.scss';
import NeurosalesSettingsPreview from './NeurosalesSettingsPreview';
import NeurosalesSettingsSetter from './NeurosalesSettingsSetter';
import { useStore } from '../../../../../store/storeUtils';
import { toJS } from 'mobx';
import { ALL_FONTS } from '../../../../../constants/fonts';
import SimpleModal from '../../../../common/SimpleModal/SimpleModal';
const DEFAULT_SETTINGS = () => JSON.parse(JSON.stringify({
  colors: {
    primaryColor: '#C76497',
    secondaryColor: '#558FE5',
    backgroundColor: '#FFFFFF',
    textColor: '#333333',
    textColorButton: '#FFFFFF'
  },
  fonts: {
    primaryFont: 'Roboto',
    secondaryFont: 'Roboto'
  },
  design: {
    buttonType: 'squared'
  }
}));
export const SettingsContext = /*#__PURE__*/createContext();
const NeurosalesSettings = observer(({
  setSettingsPage,
  renderSettings,
  allFonts = null
}) => {
  const store = useStore();
  const [showResetModal, setShowResetModal] = useState(false);
  const currentConfig = store.previewConfiguration;
  const [settingsConfig, setSettingsConfig] = useState(DEFAULT_SETTINGS());
  let copyOfCurrentSettingsInit = DEFAULT_SETTINGS();
  if (currentConfig && currentConfig.configuration && !currentConfig.configuration.settings) {
    // create settings object
    currentConfig.configuration.settings = DEFAULT_SETTINGS();
  } else if (currentConfig.configuration.settings) {
    copyOfCurrentSettingsInit = toJS(currentConfig.configuration.settings);
  }
  const [copyOfCurrentSettings, setCopyOfCurrentSettings] = useState(copyOfCurrentSettingsInit);
  const updateSettings = useCallback(newConfig => {
    setSettingsConfig(newConfig);
  }, []);
  const resetSettings = useCallback(() => {
    setShowResetModal(true);
  }, []);
  const confirmSettings = useCallback(() => {
    // update copy
    setCopyOfCurrentSettings(store.previewConfiguration.configuration.settings);

    // close settings
    if (setSettingsPage) {
      setSettingsPage(false);
    }

    // sync
    store.setRenderPreviewConfiguration(store.previewConfiguration);
    store.synchronizeWholeConfiguration();

    // re-render in CMS
    if (renderSettings) {
      renderSettings();
    }
  }, [setSettingsPage, renderSettings, store]);
  const areSettingsValid = useCallback(() => {
    //const validateResult = SETTINGS_CONFIG_VALIDATOR().validate(currentConfig.configuration.settings, {abortEarly: false});
    //return !(validateResult.error && validateResult.error.details && validateResult.error && validateResult.error.details.length > 0);

    // rimossa validazione, ora ci sono sempre dei valori di default

    return true;
  }, []);
  return currentConfig ? /*#__PURE__*/React.createElement(SettingsContext.Provider, {
    value: {
      config: settingsConfig,
      updateConfig: updateSettings,
      resetSettings: resetSettings,
      confirmSettings: confirmSettings,
      valid: areSettingsValid
    }
  }, /*#__PURE__*/React.createElement(SimpleModal, {
    onCancel: () => setShowResetModal(false),
    showModal: showResetModal,
    title: "Attenzione",
    subtitle: `Con questa operazione perderai tutte le impostazioni fino ad ora selezionate. Sei sicuro di voler continuare?`,
    onSubmit: () => {
      setShowResetModal(false);
      store.previewConfiguration.configuration.settings = copyOfCurrentSettings;
      setSettingsConfig(DEFAULT_SETTINGS());
      if (setSettingsPage) {
        setSettingsPage(false);
      }
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "cms-settings-page cms-container"
  }, /*#__PURE__*/React.createElement(NeurosalesSettingsPreview, {
    component: store.previewConfiguration.configuration.settings,
    allFonts: allFonts ? allFonts : ALL_FONTS
  }), /*#__PURE__*/React.createElement(NeurosalesSettingsSetter, {
    component: store.previewConfiguration.configuration.settings,
    allFonts: allFonts ? allFonts : ALL_FONTS
  }))) : null;
});
export default NeurosalesSettings;